<template>
  <div>
    <div class="calendar-control"  v-if="!mobile">
      <div class="calendar-title">{{ api ? api.view.title : '' }}</div>
      <div>
        <button class="control-btn" @click="changeWeekEvent('prev')">&#x276E;</button>
        <button class="today-btn" @click="today()">Сегодня</button>
        <button class="control-btn" @click="changeWeekEvent('next')">&#x276F;</button>
      </div>
    </div>
    <div class="mini-calendar" v-if="mobile">
      <mini-calendar
          @input="goto($event.toDate())"
          :value="getDate()"
      />
    </div>
    <div class="scroll">
      <div class="calendar__wrap weekGrid">
        <Calendar_Place_Chose_Modal
            v-if="place_chose.isOpen"
            :zones="zones"
            :background="chosenZone.plan_image"
            :overflow="chosenZone.plan_image"
            :isOpen="place_chose.isOpen"
            :start="popup_info.startAt"
            :end="popup_info.endAt"
            :id="popup_info.id"
            :coworkingId="coworking.id"
            :zoneId="chosenZone.id"
            :chosenCircle="chosenCircle"
            @submit="calendar_Place_Chose_Modal_submit"
            @close="placeChoseModalClose"
            @choseCircle="(v) => $emit('choseCircle', v, popup_info.id)"
            @removeCircle="(v) => $emit('removeCircle', v, popup_info.id)"
        />
        <Calendar_Create_Small_Popup
            v-if="popup_info.isVisible"
            :left="popup_info.left"
            :top="popup_info.top"
            :arrow="popup_info.arrow"
            :startAt="this.popup_info.startAt"
            :startTime="popup_info.startTime"
            :endTime="popup_info.endTime"
            :chosenRole="chosenZone.name"
            :isEdit="popup_info.isEdit"
            :coworking="coworking"
            @cancel="cancel"
            @delete="deleteEvent"
            @submit="place_chose.isOpen = true"
            @changeStartTime="v => changeTime('start', v, popup_info.id)"
            @changeEndTime="v => changeTime('end', v, popup_info.id)"
        />
        <FullCalendar
            ref="calendar"
            :options="options"
        />
      </div>
    </div>
  </div>

</template>

<script>
import FullCalendar from '@/calendar/vue/dist/main'
import interactionPlugin from '@/calendar/interaction'
import timeGridPlugin from '@/calendar/timegrid'
import Calendar_Create_Small_Popup from '@/components/Calendar/Calendar_Create_Small_Popup'
import Calendar_Place_Chose_Modal from '@/components/Calendar/Calendar_Place_Chose_Modal'
import {mapMutations} from 'vuex'
import MiniCalendar from "@/pages/Cabinet/Master/CalendarApi/miniCalendar";

export default {
  name: "WeekGrid",
  components: { MiniCalendar, Calendar_Place_Chose_Modal, Calendar_Create_Small_Popup, FullCalendar},
  mounted() {
    this.options.events = this.events;
    this.api = this.$refs.calendar.getApi()
    if(window.innerWidth < 785){
      this.mobile = true;
      this.api.changeView('timeGridDay')
    }
    this.changeWeekEvent();
  },
  props: [
    'chosenZone',
    'events',
    'placesBackground',
    'blockRoleSelect',
    'newEvents',
    'zones',
    'coworking'
  ],
  data() {
    return {
      ...mapMutations(['openModal']),
      place_chose: {
        isOpen: false
      },
      mobile: false,
      api: null,
      popup_info: {
        left: 0,
        top: 0,
        startTime: "00:00",
        endTime: "00:00",
        arrow: 'right',
        isVisible: false,
        isEdit: false,
        id: null
      },
      options: {
        plugins: [interactionPlugin, timeGridPlugin],
        initialView: 'timeGridWeek',
        locale: 'ru',
        selectable: true,
        headerToolbar: false,
        stickyHeaderDates: false,
        buttonText: {
          today: 'Сегодня'
        },
        customButtons: {
          prev: {
            click: () => this.changeWeekEvent('prev'),
          },
          next: {
            click: () => this.changeWeekEvent('next'),
          }
        },
        slotMinTime: "10:00:00",
        slotMaxTime: "21:00:00",
        slotDuration: "01:00:00",
        allDaySlot: false,
        slotEventOverlap: false,
        firstDay: 1,
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit'
        },
        titleFormat: {
          month: 'long',
          year: 'numeric'
        },
        height: 'auto',
        windowResize: this.resize,
        select: this.createEvent,
        eventClick: this.eventClick,
        events: [],
        displayEventTime: false
      },
      create_popup_data: {
        name: '',
        startTime: '',
        endTime: '',
        date: '',
        type: ''
      },
    }
  },
  computed: {
    chosenCircle() {
      return this.newEvents.find(evts => evts.id === this.popup_info.id).workplaces
    },
  },
  methods: {
    goto(date) {
      this.api.gotoDate ( date )
    },
    getDate() {
      return this.api.getDate()
    },
    resize() {
      if(window.innerWidth < 785){
        this.api.changeView('timeGridDay')
      }else{
        this.api.changeView('timeGridWeek')
      }
      this.mobile = window.innerWidth < 785;
      this.$emit('mobile', this.mobile)
    },
    createEvent(e) {
      if (this.$moment(e.startStr).diff(this.$moment(), 'minutes') <= 0) return this.$toast.error('Невозможно создать аренду на прошедшую дату!');
      if (!this.chosenZone) return this.$toast.error('Выберите рабочую зону!');
      const id = `temp_id:${(Math.random() * Math.random() * 100)}`
      this.popup_info.isEdit = false;
      this.popup_info.isVisible = true;
      this.popup_info.id = id;
      this.popup_info.startAt = e.startStr;
      this.popup_info.endAt = e.endStr;
      this.setPosition(e);
      this.setTime(e);
      this.$emit('blockRoles', true)
      this.$emit('pushEvent', {
        start: e.startStr,
        end: e.endStr,
        id,
        backgroundColor: '#fff',
        isNew: true,
        borderColor: this.coworking.color,
        coworkingId: this.coworking.id,
        zoneId: this.chosenZone.id,
        title: this.chosenZone.name,
        workplaces: []
      });
    },
    eventClick(e) {
      // if event has not id
      if (e.event.id.includes('temp_id:')) {
        this.popup_info.id = e.event.id
        this.popup_info.isEdit = true
        this.popup_info.isVisible = true
        this.popup_info.chosenRole = this.chosenZone.name
        this.popup_info.startAt = e.event.startStr;
        this.popup_info.endAt = e.event.endStr;
        this.setPosition(e, 'edit')
        this.setTime(e, 'edit')
      }
    },
    changeWeekEvent(method) {
      let calendarApi = this.$refs.calendar.getApi();
      if (method) calendarApi[method]();
      let range = calendarApi.currentData.dateProfile.renderRange;
      this.$emit('changedWeek', this.$moment(range.start).set('hour', 1), this.$moment(range.end).subtract(1, 'day').set('hour', 23));
    },
    today(){
      let calendarApi = this.$refs.calendar.getApi();
      let range = calendarApi.currentData.dateProfile.renderRange;
      calendarApi.today()
      this.$emit('changedWeek', this.$moment(range.start).set('hour', 1), this.$moment(range.end).subtract(1, 'day').set('hour', 23));
    },
    setPosition(e, type = 'default') {
      // e.jsEvent.clientX
      this.popup_info.left = e.jsEvent.pageX + 'px'

      let startStr = e.startStr
      let endStr = e.endStr

      if (type === 'edit') {
        startStr = e.event.startStr
        endStr = e.event.endStr
      }
      /* top */
      const startVal = startStr
          .split('T')[1]
          .split(':')[0]

      const endVal = endStr
          .split('T')[1]
          .split(':')[0]
      const top_delta = endVal - startVal

      this.popup_info.top = ((startVal - 10) * 44) + (top_delta * 22) - 105 + 130 + 'px'
      let left_pos = e.jsEvent.clientX - ((document.body.offsetWidth - 1195) / 2)

      /* left */
      let startDay = e.start
      if (type === 'edit') {
        startDay = e.event.start
      }

      if (startDay.getDay() === 0 || startDay.getDay() === 6) {
        this.popup_info.arrow = 'left'
        left_pos = left_pos - 380
      } else {
        this.popup_info.arrow = 'right'
        left_pos = left_pos + 100
      }

      this.popup_info.left = left_pos + 'px'
    },
    setTime(e, type = 'default') {
      let start = e.start
      let end = e.end
      // edit type
      if (type === 'edit') {
        start = e.event.start
        end = e.event.end
      }
      // start
      const start_hours = start.getHours()
      let start_minutes = start.getMinutes()
      // end
      const end_hours = end.getHours()
      let end_minutes = end.getMinutes()
      // zero add to start
      if (start_minutes.toString().length < 2) {
        start_minutes = '0' + start_minutes
      }
      // zero add to end
      if (end_minutes.toString().length < 2) {
        end_minutes = '0' + end_minutes
      }
      // final constants
      const startTime = `${start_hours}:${start_minutes}`
      const endTime = `${end_hours}:${end_minutes}`
      this.popup_info.startTime = startTime
      this.popup_info.endTime = endTime
    },
    changeTime(type, value, id) {
      if (type === 'start') {
        this.popup_info.startTime = value
        this.$emit('changeTime', 'start', value, id)
      } else if (type === 'end') {
        this.popup_info.endTime = value
        this.$emit('changeTime', 'end', value, id)
      }
    },
    cancel() {
      // Popup info to default
      this.popup_info = {
        left: 0,
        top: 0,
        startTime: "00:00",
        endTime: "00:00",
        arrow: 'right',
        isVisible: false,
        id: null,
        startAt: null,
        endAt: null
      }
      // Removing new event
      this.$emit('removeNewEvent')
      // Unblocking roles
      this.$emit('blockRoles', false)
    },
    calendar_Place_Chose_Modal_submit() {
      this.$emit('submit', this.popup_info.id)
      this.$emit('blockRoles', false)
      this.place_chose.isOpen = false
      this.popup_info = {
        left: 0,
        top: 0,
        startTime: "00:00",
        endTime: "00:00",
        arrow: 'right',
        isVisible: false,
        id: null,
        startAt: null,
        endAt: null,
      }
    },
    deleteEvent() {
      this.$emit('delete', this.popup_info.id)
      this.popup_info.isEdit = false
      this.popup_info.isVisible = false
    },
    placeChoseModalClose() {
      if (this.chosenCircle.length > 0) {
        this.place_chose.isOpen = false
      } else {
        // w
        this.cancel()
        this.place_chose.isOpen = false
      }
    }
  },
  watch: {
    events(v) {
      this.options.events = v
    }
  },
}
</script>
<style>
@media (max-width: 800px){
  .fc-col-header-cell{
    display: none;
  }
}
</style>
<style lang="scss">
.calendar__wrap {
  padding: 0;
  position: relative;
}

.calendar-control {
  padding: 30px 30px 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

button {
  background-color: unset;
  border: unset;
}

.calendar-title {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
}

.control-btn {
  color: #DBBFA7;
  margin-left: 19px;
  margin-right: 19px;
}

.today-btn {
  border: 1px solid #DBBFA7;
  border-radius: 5px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #DBBFA7;
  padding: 2px 15px;
}
.weekGrid {
  padding: 30px 10px 20px;
  position: relative;

  .fc {
    .fc-toolbar-title {
      font-weight: 600;
      font-size: 24px;
      line-height: 1.33;
      color: #383838;
      text-transform: capitalize;
    }

    .fc-button {
      border: none;
      background-color: transparent;
      width: 20px;
      height: 20px;
      padding: 0;

      &[aria-label="prev"] {
        background-image: url("../../assets/images/icons/chevron-left.svg");
      }

      &[aria-label="next"] {
        background-image: url("../../assets/images/icons/chevron-right.svg");
      }

      span {
        font-size: 0;
      }

      &:focus, &:active {
        box-shadow: none;
        background-color: transparent;
      }
    }

    .fc-today-button {
      width: 100px;
      height: 32px;
      border: 1px solid #B9765B;
      border-radius: 5px !important;

      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 1;
      color: #B9765B;
      margin: 0 10px !important;

      &:not(:disabled):active {
        color: #B9765B;
        border: 1px solid #B9765B;
      }
    }

    .fc-button-group {
      align-items: center;
    }

    .fc-button-primary:not(:disabled):active:focus, .fc .fc-button-primary:not(:disabled).fc-button-active:focus {
      box-shadow: none;
    }

    .fc-timegrid-slot {
      height: 44px;
    }

    .fc-col-header-cell-cushion {
      font-weight: 400;
      font-family: "Open Sans", sans-serif;
      text-transform: capitalize;
      font-size: 20px;
      line-height: 1.4;
      color: #383838;
    }

    &-theme-standard th {
      border: none;
      padding-bottom: 14px;
    }

    &-theme-standard .fc-scrollgrid {
      border: none;
    }

    .fc-timegrid-slot-label-cushion {
      transform: translateX(-100%);
      width: 20px;

      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      line-height: 1.67;
      letter-spacing: 1px;
      color: #808080;
    }

    .fc-scroller-harness {
      overflow: visible;
    }

    .fc-scroller-liquid-absolute {
      overflow: visible !important;
    }

    .fc-view-harness-active > .fc-view {
      padding-left: 40px;
      width: calc(100% - 40px);
    }

    .fc-scrollgrid-section-body table:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 1px;
      top: 0;
      background-color: #E5E5E5;
    }

    .fc-theme-standard td, .fc-theme-standard th {
      border: 1px solid #E5E5E5;
    }

    .fc-v-event .fc-event-title-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .fc-v-event .fc-event-title {
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      line-height: 1.2;
      color: #383838;
    }
  }
}

@media(max-width: 785px) {
  .calendar-title {
    max-width: 270px;
  }
}
</style>
